import type { PropsWithChildren } from 'react';
import React from 'react';

import { CompanyHubPageLayout } from '@confluence/page-layout/entry-points/CompanyHubPageLayout';

/**
 * The {@link https://staging.atlassian.design/components/navigation-system/page-layout | page layout} of the Company Hub app-like experience at Team '25 US.
 *
 * Inspired by `MainLayout` at confluence/next/packages/main-layout/src/MainLayout.tsx and `MainLayoutComponent`.
 *
 * @see {@link https://www.figma.com/design/MBdUXhdmgbsIkMkOhQGu5e/Hub-App?node-id=101-52260}
 * @see {@link https://hello.atlassian.net/wiki/spaces/CLI/pages/4856024337/Confluence-less+Team+25+US+Experience}
 */
export const CompanyHubMainLayout = ({ children }: CompanyHubMainLayoutProps) => (
	<CompanyHubPageLayout>{children}</CompanyHubPageLayout>
);

type CompanyHubMainLayoutProps = PropsWithChildren<{}>;
